module.exports = {
	"**** PROVIDER ****": "AWS | FIREBASE",
	"PROVIDERS": [
		"FIREBASE",
		"AWS"
	],
	"**** OAUTH ****": "",
	"OAUTH": {
		"GOOGLE": {
			"APP_KEY": "262782035764-3n0m6uni2i7bu27ov6aac8q10991u6pk.apps.googleusercontent.com"
		}
	},
	"**** AWS ****": "",
	"AWS": {
		"REGION": "us-east-1",
		"IOT": {
			"USER": {
				"ACCESS_KEY": "AKIAI2AXTTXC3RRPG74Q",
				"SECRET_KEY": "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"
			},
			"ENDPOINT": "a174nws58jlk61.iot.us-east-1.amazonaws.com",
			"TOPIC": "$aws/things/serverless-webapp/shadow/update"
		},
		"COGNITO": {
			"IDENTITY_POOL_ID": "us-east-1:cef92dbf-26bd-4928-9801-9e985985e17c"
		},
		"GOOGLE": {
			"ROLE_ARN": "arn:aws:iam::334066760643:role/googleIdentityRole"
		},
		"FUNCTIONS": {
			"INVOKE_URL": "https://42z2qxbtzk.execute-api.us-east-1.amazonaws.com/prod"
		}
	},
	"**** FIREBASE ****": "",
	"FIREBASE": {
		"apiKey": "AIzaSyCF_PEkDI5fFTiaBhy_hw_Al6KUpYklNHM",
		"authDomain": "serverless-vienna.firebaseapp.com",
		"databaseURL": "https://serverless-vienna.firebaseio.com",
		"projectId": "serverless-vienna",
		"storageBucket": "serverless-vienna.appspot.com",
		"messagingSenderId": "262782035764"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 85
// module chunks = 0